import { Box, Stack, Typography } from '@mui/material';
import { DefaultizedPieValueType, PiePlot, pieArcLabelClasses } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { format } from 'date-fns';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';

export const CarsByBranchPie = ({ graphData }: DealerAccidentsOverviewProps) => {
  const values = graphData?.totals?.carsByBranch?.values;
  if (!values?.length) return null;

  const totalCount = values.reduce((acc, item) => acc + item.count, 0);
  const todayFormatted = format(new Date(), 'dd.MM.yyyy');

  const pieData = values.map((item) => ({
    label: item.name,
    value: item.count,
    color: item.color
  }));

  const getArcLabel = (params: DefaultizedPieValueType) => {
    const item = values.find((v) => v.count === params.value);
    if (!item) return '';
    return `${item.percentage}%`;
  };

  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Poměr interních aut na pobočkách
          </Typography>
          <Typography variant="body2" color="gray">
            V reálném čase k aktuálnímu dni: {todayFormatted}
          </Typography>
          <Typography variant="body2" color="gray">
            Celkem aut: {totalCount}
          </Typography>
        </>
      }
    >
      <Box width={1} height="320px">
        <ResponsiveChartContainer
          skipAnimation
          margin={{ bottom: 10 }}
          series={[{ type: 'pie', data: pieData, arcLabel: getArcLabel }]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'black',
              fontSize: 11
            }
          }}
        >
          <PiePlot />
        </ResponsiveChartContainer>
      </Box>
      <Stack mt={1} spacing={0.5}>
        {values.map((item) => (
          <Stack key={item.name} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '2px',
                bgcolor: item.color,
                flexShrink: 0
              }}
            />
            <Typography fontSize={11}>
              <Typography component="span" fontSize={11} fontWeight="bold">
                {item.name}
              </Typography>
              {`: ${item.percentage}% (${item.count} aut) / průměrné stáří vozu: ${item.avgCarsAge} let`}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </BoxWithHeader>
  );
};
